@if (iconOnly) {
  <button
    mat-icon-button
    [class]="buttonClass"
    [disabled]="disabled || loading"
    [attr.type]="type"
  >
    @if (loading) {
      <hugeicons-icon
        class="ma-btn__spin"
        [icon]="iconStart ?? iconCenter ?? iconEnd ?? loadingIcon"
        [size]="18"
        [strokeWidth]="1.75"
        color="currentColor"
      />
    } @else {
      <hugeicons-icon
        [icon]="iconStart ?? iconCenter ?? iconEnd ?? loadingIcon"
        [size]="18"
        [strokeWidth]="1.75"
        color="currentColor"
      />
    }
  </button>
} @else if (isRaised) {
  <button
    mat-flat-button
    [class]="buttonClass"
    [disabled]="disabled || loading"
    [attr.type]="type"
  >
    <span class="ma-btn__label">
      @if (loading) {
        <span class="ma-btn__icon">
          <hugeicons-icon
            class="ma-btn__spin"
            [icon]="iconStart ?? iconCenter ?? iconEnd ?? loadingIcon"
            [size]="18"
            [strokeWidth]="1.75"
            color="currentColor"
          />
        </span>
      } @else if (iconStart) {
        <span class="ma-btn__icon">
          <hugeicons-icon [icon]="iconStart" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      @if (iconCenter && iconCenterPosition === 'left' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      {{ label }}
      <ng-content />
      @if (iconCenter && iconCenterPosition === 'right' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
    </span>
    @if (iconEnd && !loading) {
      <span class="ma-btn__icon">
        <hugeicons-icon [icon]="iconEnd" [size]="18" [strokeWidth]="1.75" color="currentColor" />
      </span>
    }
  </button>
} @else if (isStroked) {
  <button
    mat-stroked-button
    [class]="buttonClass"
    [disabled]="disabled || loading"
    [attr.type]="type"
  >
    <span class="ma-btn__label">
      @if (loading) {
        <span class="ma-btn__icon">
          <hugeicons-icon
            class="ma-btn__spin"
            [icon]="iconStart ?? iconCenter ?? iconEnd ?? loadingIcon"
            [size]="18"
            [strokeWidth]="1.75"
            color="currentColor"
          />
        </span>
      } @else if (iconStart) {
        <span class="ma-btn__icon">
          <hugeicons-icon [icon]="iconStart" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      @if (iconCenter && iconCenterPosition === 'left' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      {{ label }}
      <ng-content />
      @if (iconCenter && iconCenterPosition === 'right' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
    </span>
    @if (iconEnd && !loading) {
      <span class="ma-btn__icon">
        <hugeicons-icon [icon]="iconEnd" [size]="18" [strokeWidth]="1.75" color="currentColor" />
      </span>
    }
  </button>
} @else {
  <button
    mat-button
    [class]="buttonClass"
    [disabled]="disabled || loading"
    [attr.type]="type"
  >
    <span class="ma-btn__label">
      @if (loading) {
        <span class="ma-btn__icon">
          <hugeicons-icon
            class="ma-btn__spin"
            [icon]="iconStart ?? iconCenter ?? iconEnd ?? loadingIcon"
            [size]="18"
            [strokeWidth]="1.75"
            color="currentColor"
          />
        </span>
      } @else if (iconStart) {
        <span class="ma-btn__icon">
          <hugeicons-icon [icon]="iconStart" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      @if (iconCenter && iconCenterPosition === 'left' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
      {{ label }}
      <ng-content />
      @if (iconCenter && iconCenterPosition === 'right' && !loading) {
        <span class="ma-btn__icon ma-btn__icon--center">
          <hugeicons-icon [icon]="iconCenter" [size]="18" [strokeWidth]="1.75" color="currentColor" />
        </span>
      }
    </span>
    @if (iconEnd && !loading) {
      <span class="ma-btn__icon">
        <hugeicons-icon [icon]="iconEnd" [size]="18" [strokeWidth]="1.75" color="currentColor" />
      </span>
    }
  </button>
}

<!-- Outside the button: Material clips its overflow, which would cut the badge in half. -->
@if (badge) {
  <span class="ma-btn__badge">{{ badge }}</span>
}
